<template>
    <div class="frameSec settingsPage">
        <AddressBook />
    </div>
</template>

<script>
    import AddressBook from '../../components/Settings/AddressBook';

    export default {
        name: "PaymentMethods",
        computed : {

        },
        components: {
            AddressBook
        }
    }
</script>
